import {getSelectItemLabel} from '~/components/Controls/Select';
import {IModel} from '~/lib/model';

export enum EntityType {
    ACCOUNT_INFO = 'ACCOUNT_INFO',
    AGENCY = 'AGENCY',
    APP_ADS = 'APP_ADS',
    BIDDER = 'BIDDER',
    BIDDER_GROUP = 'BIDDER_GROUP',
    EXCHANGE_CONFIG = 'EXCHANGE_CONFIG',
    PAYMENT_DETAILS = 'PAYMENT_DETAILS',
    PRETARGETING_CONFIG = 'PRETARGETING_CONFIG',
    PRETARGETING_RULES = 'PRETARGETING_RULES',
    PRETARGETING_VARIABLE = 'PRETARGETING_VARIABLE',
    SELLER = 'SELLER',
    SELLER_BLOCKING_SETTINGS = 'SELLER_BLOCKING_SETTINGS',
    SOURCE = 'SOURCE',
    SUPPLY_PACKAGE = 'SUPPLY_PACKAGE',
    DEAL = 'DEAL',
    EXPENSE = 'EXPENSE',
    DISTRIBUTION_LINE = 'DISTRIBUTION_LINE'
}

export const entityTypes: { value: EntityType; label: string }[] = [
    {value: EntityType.ACCOUNT_INFO, label: 'Account info'},
    {value: EntityType.AGENCY, label: 'Agency'},
    {value: EntityType.APP_ADS, label: 'App-ads.txt'},
    {value: EntityType.BIDDER, label: 'Bidder'},
    {value: EntityType.BIDDER_GROUP, label: 'Bidder group'},
    {value: EntityType.EXCHANGE_CONFIG, label: 'Global config'},
    {value: EntityType.PAYMENT_DETAILS, label: 'Payment details'},
    {value: EntityType.PRETARGETING_CONFIG, label: 'Pretargeting config'},
    {value: EntityType.PRETARGETING_RULES, label: 'Pretargeting rules'},
    {value: EntityType.PRETARGETING_VARIABLE, label: 'Pretargeting variable'},
    {value: EntityType.SELLER, label: 'Seller'},
    {value: EntityType.SELLER_BLOCKING_SETTINGS, label: 'Seller blocking settings'},
    {value: EntityType.SOURCE, label: 'Source'},
    {value: EntityType.SUPPLY_PACKAGE, label: 'Supply package'},
    {value: EntityType.DEAL, label: 'Deal'},
    {value: EntityType.EXPENSE, label: 'Expense'},
    {value: EntityType.DISTRIBUTION_LINE, label: 'Line Management'}
];

export const getEntityTypeLabel = (entityType: EntityType) => getSelectItemLabel(entityTypes, entityType);

export enum OperationType {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE'
}

export const operationTypes: { value: OperationType; label: string }[] = [
    {value: OperationType.CREATE, label: 'Create'},
    {value: OperationType.UPDATE, label: 'Update'},
    {value: OperationType.DELETE, label: 'Delete'}
];

export const getOperationTypeLabel = (operationType: OperationType) => getSelectItemLabel(operationTypes, operationType);

export interface IAudit extends IModel {
    id: string;
    userId: string;
    entityId: string;
    entityType: EntityType;
    operationType: OperationType;
    entity: string;
    timestamp?: string;
}
